import React from 'react';
import { Rocket } from 'lucide-react';
import { PROCESS_STEPS } from '../data/siteData';
import useReveal from '../hooks/useReveal';

function Step({ step, index }) {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      className={`process-step reveal ${step.isLiftOff ? 'process-step-liftoff' : ''}`}
      style={{ transitionDelay: `${index * 120}ms` }}
      data-testid={`process-step-${index + 1}`}
    >
      <div className="process-count">
        {step.isLiftOff ? <Rocket size={38} strokeWidth={2.2} /> : step.count}
      </div>
      <div className="process-body">
        <h3 className="process-title">{step.title}</h3>
        <p className="process-desc">{step.description}</p>
      </div>
      {index < PROCESS_STEPS.length - 1 && <div className="process-connector" aria-hidden="true" />}
    </div>
  );
}

export default function Process() {
  const headRef = useReveal();
  return (
    <section className="section process-section" id="process" data-testid="process-section">
      <div className="section-inner">
        <div className="section-head reveal" ref={headRef}>
          <span className="section-eyebrow">// LAUNCH SEQUENCE</span>
          <h2 className="section-title">
            3…2…1… <span className="text-pink">LIFT-OFF!</span>
          </h2>
          <p className="section-sub">Our countdown to getting your brand off the ground.</p>
        </div>

        <div className="process-grid">
          {PROCESS_STEPS.map((step, i) => (
            <Step key={step.title} step={step} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
